import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, ExternalLink, Mail, MapPin } from 'lucide-react';
import { siteInfo } from '../../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#111111] text-white">
      <div className="container-luxury py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          {/* Brand */}
          <div className="space-y-6">
            <Link to="/" className="font-serif text-2xl tracking-wide">
              {siteInfo.name}
            </Link>
            <p className="caption-text text-white/60">
              {siteInfo.tagline}
            </p>
          </div>

          {/* Navigation */}
          <div className="space-y-6">
            <h4 className="nav-link text-white/40">Navigation</h4>
            <nav className="flex flex-col gap-4">
              <Link to="/portfolio" className="nav-link text-white/70 hover:text-white transition-colors duration-300">Portfolio</Link>
              <Link to="/about" className="nav-link text-white/70 hover:text-white transition-colors duration-300">À Propos</Link>
              <Link to="/services" className="nav-link text-white/70 hover:text-white transition-colors duration-300">Services</Link>
              <Link to="/contact" className="nav-link text-white/70 hover:text-white transition-colors duration-300">Contact</Link>
            </nav>
          </div>

          {/* Contact */}
          <div className="space-y-6">
            <h4 className="nav-link text-white/40">Contact</h4>
            <div className="flex flex-col gap-4">
              <a 
                href={`mailto:${siteInfo.email}`} 
                className="flex items-center gap-3 nav-link text-white/70 hover:text-white transition-colors duration-300"
              >
                <Mail size={14} strokeWidth={1.5} />
                {siteInfo.email}
              </a>
              <div className="flex items-center gap-3 nav-link text-white/70">
                <MapPin size={14} strokeWidth={1.5} />
                {siteInfo.location}
              </div>
              <div className="flex items-center gap-6 mt-4">
                <a 
                  href={siteInfo.instagram} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-white/70 hover:text-white transition-colors duration-300"
                  aria-label="Instagram"
                >
                  <Instagram size={18} strokeWidth={1.5} />
                </a>
                <a 
                  href={siteInfo.behance} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-white/70 hover:text-white transition-colors duration-300"
                  aria-label="Behance"
                >
                  <ExternalLink size={18} strokeWidth={1.5} />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-16 pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="caption-text text-white/40">
              © {currentYear} {siteInfo.name}. Tous droits réservés.
            </p>
            <p className="caption-text text-white/40">
              Fine Art & Editorial Photography
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
